module.exports = __webpack_public_path__ + "media/images/emblems/Le_Paquier_FR-coat_of_arms-6982da345b07494e6209a857094d35f6.svg";